<template>
  <div class="product-row">
    <span class="sk-text-medium-regular">
      {{ name }}
    </span>
    <SkOroraTag
      v-if="discountTag"
      size="medium"
    >
      {{ discountTag }}
    </SkOroraTag>
    <div class="product-row__price">
      <span
        v-if="originalPrice"
        class="sk-text-small-regular text--grey text--stroked"
      >
        {{ originalPrice }}
      </span>
      <span class="sk-text-medium-regular">
        {{ finalPrice }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductRow',
  props: {
    name: {
      type: String,
      required: true,
    },
    discountTag: {
      type: String,
      default: null,
    },
    originalPrice: {
      type: String,
      default: null,
    },
    finalPrice: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@use './shared' as *;

.product-row {
  display: flex;
  flex: 1;
  gap: 4px;
}

.product-row__price {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  align-items: center;
}
</style>
